import { ISearchListColumn } from 'component/Search/types';
import { startCase } from 'lodash';
import { TFunction } from 'i18next';

/** Takes an IColumn-like item, and hydrates several standardized parameters for use in an
 * office fabric DetailsList. To override any specific IColumn property this function sets,
 * just set that property on the passed column.
 * @param columnProps Columnlike to hydrate into a standardized column
 * @returns DetailsList column
 */

export const hydrateStandardIColumn = (
  columnProps: Partial<ISearchListColumn>,
  t: TFunction
): ISearchListColumn => {
  const { key } = columnProps;
  // inject translations
  const genName = columnProps?.name || startCase(key)?.replace('Cve', 'CVE');
  const name = t(`${genName}`, {
    ns: 'search',
    defaultValue: genName,
  });

  const isDate = key && key.indexOf('Date') >= 0;
  const minWidth = isDate ? 73 : 150;
  const maxWidth = isDate ? 76 : 350;

  return {
    //@ts-ignore shoehorn to make this work for now
    key: key,
    minWidth,
    maxWidth,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: true,
    ...columnProps,
    // We intentionally override columnProps' name and fieldname with our generated ones.
    fieldName: columnProps.fieldName || key,
    name,
  };
};
